import { useState, useCallback, useEffect } from 'react';
import { getApiBaseUrl } from '../../../../core/config/api';
import { type InstanceRow } from '../../components/interventions/instanceModel';

interface UseInterventionsParams {
  currentUser: { id: number } | null;
  authHeaders: () => Record<string, string>;
}

export function useInterventions({ currentUser, authHeaders }: UseInterventionsParams) {
  const [interventions, setInterventions] = useState<InstanceRow[]>([]);

  const loadInterventions = useCallback(async () => {
    if (!currentUser?.id) return;
    try {
      const res = await fetch(`${getApiBaseUrl()}/api/cta/interventions`, {
        headers: authHeaders(),
      });
      const data = await res.json().catch(() => ({}));
      if (data?.success && Array.isArray(data?.interventions)) {
        setInterventions(data.interventions as InstanceRow[]);
      }
    } catch {
      // silencieux
    }
  }, [currentUser?.id, authHeaders]);

  useEffect(() => {
    if (!currentUser) return;
    let cancelled = false;
    const run = async () => { if (!cancelled) await loadInterventions(); };
    void run();
    const id = window.setInterval(run, 30000);
    return () => { cancelled = true; window.clearInterval(id); };
  }, [currentUser, loadInterventions]);

  return { interventions, setInterventions, loadInterventions };
}
